import { StoreEnhancer, compose } from 'redux';
import { Store } from '../store/types';

export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}

export enum PurchaseType {
  INAPP = 'inapp',
  SUBS = 'subs',
}

interface AzarJs {
  /**
   * The LoginResponse returned from login API, jsonified.
   */
  getLoginResponseJson: () => string;

  /**
   * Current platform.
   */
  getPlatform: () => Platform;

  /**
   * Locale of the current user interface, should be one of the supported ui locales of Azar.
   * e.g. "en", "pt", "zh_CN" etc.
   */
  getUiLocale: () => string;

  /**
   * Returns the jsonified array of {@link ProductPriceInfo}. The list should include all the regular gem products,
   * obtained from getGooglePlayProductInfos etc, plus promotion products from LoginResponse.gemPromotionInfo.
   * @returns {string} Jsonified array of {@link ProductPriceInfo}
   * @see {@link ProductPriceInfoListUpdated}
   */
  getProductPriceInfoListJson: () => string;

  /**
   * [deprecate(this.startPurchaseV2, "Newer clients should implement startPurchaseV2 instead")];
   * Start purchasing process. When the purchase process is fniished, successfully or not, "purchaseFinished" callback
   * is invoked.
   * @param {string} productId the productId to purchase
   * @see {@link PurchaseFinished}
   */
  startPurchase: (productId: string) => void;

  /**
   * Start purchasing process. When the purchase process is finished, successfully or not, "purchaseFinished" callback
   * is invoked.
   * @param {string} productId the productId to purchase
   * @param {string} itemType item type of product, "inapp" for in-app product, or "subs" for subscription
   * @see {@link PurchaseFinished}
   */
  startPurchaseV2: (productId: string, itemType: PurchaseType) => void;

  /**
   * Close current popup. No-op in full-screen webview.
   */
  closePopup: () => void;

  /**
   * Reload page to refresh token from the API
   */
  reload: () => void;

  /**
   * 인앱결제
   */
  startPurchaseInAppMarket: (productId: string) => void;

  /**
   * report error to client for log when pg payment
   * @param orderId
   * @param productId
   * @param billingResponse
   */
  handlePgPurchaseResult: (orderId: string, productId: string, errorCode: string) => void;
  setNavigation: (isVisible: string) => void;
}

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: (storeEnhancer: StoreEnhancer) => typeof compose;
    AzarJs?: AzarJs;
    store: Store;
    _i18next: any;
    productPriceInfoListUpdated: () => void;
    purchaseFinished: (productId: string, success: boolean, errmsg?: string) => void;
  }
}
